import { render, staticRenderFns } from "./BtnInserirDespesas.vue?vue&type=template&id=1d8cd535"
import script from "./BtnInserirDespesas.vue?vue&type=script&lang=js"
export * from "./BtnInserirDespesas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports